module.exports = __webpack_public_path__ + "img/jd_nodate@2x.37e6acf2.png";